module Meevo.Plugins.ReferralTypes {
    "use strict";

    /**
    * Main Section of Referral Type 
    */
    export class MainSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.ReferralType> {

        /**
        * Base class override which defines what a DEFAULT model looks like.
        */
        createSectionModelInstance(postAdd:(data:any)=>any): void {
            this.dataService.getTemplate(this.baseEndpoint).then((data) => {
                this.model = data;
            });
        }

    }

}